<template>
  <div class="upgrade-item upgrade-item-speedy">
    <div class="upgrade-checkbox"></div>
    <div class="upgrade-label">
      <span style="cursor: pointer">Turnaround Time</span>
      <div class="turnaround-slider">
        <!-- <div class="turnaround-line"></div> -->
        <div
          class="turnaround-option-container"
          v-for="(option, i) in options"
          :key="option"
        >
          <div
            class="turnaround-option"
            :class="{ 'turnaround-option-selected': selectedOption === option }"
            @click="clickOption(option)"
          >
            {{ option }}
            <div class="turnaround-check">
              <i class="material-icons turnaround-check-icon">check_circle</i>
            </div>
          </div>
          <div class="turnaround-line" v-if="i !== 2"></div>
        </div>
        <div class="turnaround-label">days</div>
        <!-- <div class="turnaround-line"></div> -->
      </div>
      <div class="upgrade-more">
        <p>
          Choose the number of days your reader is given to read your book
          <br />and turn in their review.
        </p>
        <p v-if="reccomendedCountries">
          <b>Your book will only be shown to readers in {{ reccomendedCountries }}.</b>
          <span v-if="reccomendedExtraTime"> <br>Because of your regional preferances for reviews, it may take longer than average to find a reader. <br>We'll do our best to promote your book to readers in your perfered {{ plurralizedRegion }}!</span>
        </p>
        <p>
          The recommended days based on your page length <span v-if="reccomendedExtraTime"> and regional preferances</span>:
          {{ recommendedOption }} days.
        </p>
      </div>
    </div>
    <div v-if="snapCost" class="item-cost">
      <div class="points-tag" :class="{pulseOnce: shakeSnaps}">
        <div class="points-increase">+</div>
        <div class="points-icon">
          <img src="/images/icons/snap.svg" class="snaps-icon" />
        </div>
        <div class="points-number">{{ snapCost }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "@/modules/Back";
import Bus from "@/modules/Bus";
import { mapState } from "vuex";

export default {
  name: "TurnaroundOption",
  props: ["book", "onSelect", "defaultOption"],
  data: function () {
    return {
      selectedOption: null,
      recommendedOption: 5,
      reccomendedCountries: null,
      reccomendedExtraTime: false,
      snapCost: 0,
      shakeSnaps: false,
      options: [],
    };
  },
  computed: {
    ...mapState({
      user: "user",
      allowedCountries: "allowedCountries"
    }),
    plurralizedRegion() {
      if (this.user.country_lock.length > 1) {
        return "regions"
      } else {
        return "region"
      }
    },
  },
  methods: {
    clickOption(option) {
      this.selectedOption = option;
      this.flashPointsChange()
      this.snapCost = (this.recommendedOption - this.selectedOption) * 100;

      this.onSelect(option, this.snapCost);
    },
    flashPointsChange() {
      this.shakeSnaps = true
        setTimeout(() => {
          this.shakeSnaps = false;
          }, 500);
    },
  },
  created() {
    const length = this.book.word_count;
    if (length > 80000) {
      this.recommendedOption = 5;
    } else if (length > 25000) {
      this.recommendedOption = 4;
    } else {
      this.recommendedOption = 3;
    }
    if (this.user.country_lock.length != 0) {
      // this.allowedCountries = this.$store.state.allowedCountries;
      let reccomendedCountryArray = []
      this.user.country_lock.forEach((countryCode) => {
          this.allowedCountries.forEach((country) => {
            if (country.country_code === countryCode) {
              reccomendedCountryArray.push(country.country_name)
            }
          })
      })

      this.reccomendedCountries = reccomendedCountryArray.join(", ")
      this.reccomendedCountries = this.reccomendedCountries.replace(/,([^,]*)$/, ', and $1')

      // If there is only one comma in the string (ie two elements split on commas) then remove the comma
      if (this.reccomendedCountries.split(",").length === 2){
        this.reccomendedCountries = this.reccomendedCountries.replace(/,/, '')
      }
      // Replace the first instance of "United" with "the United"
      if (this.reccomendedCountries.indexOf("United") >= 0){
        this.reccomendedCountries = this.reccomendedCountries.replace(/(United)/, 'the $1')
      }
      // Modify the recommended reading option based on inclusion of US Market
      if (this.reccomendedCountries.indexOf("United States") < 0) {
        this.reccomendedExtraTime = true
        this.recommendedOption += 2
      }
    }

    var currentOption = this.recommendedOption;

    this.options.push(currentOption);
    this.options.push(currentOption - 1);
    this.options.push(currentOption - 2);

    if (this.defaultOption) {
      this.clickOption(this.defaultOption);
    } else {
      this.clickOption(currentOption)
    }
  },
};
</script>

<style lang="scss" scoped>
.turnaround-container {
  display: flex;
}

.item-cost {
  margin-left: auto;
}

.turnaround-slider {
  display: flex;
  margin: 8px 0 4px 0;
}
.turnaround-option-container {
  display: flex;
}
.turnaround-line {
  width: 30px;
  height: 3px;
  margin-top: 18px;
  background: lighten(#43a047, 45%);
}
.turnaround-option {
  width: 36px;
  height: 36px;
  background: #fff;
  padding-top: 1px;
  border: 3px solid lighten(#43a047, 45%);
  border-radius: 38px;
  color: #777;
  color: lighten(#43a047, 20%);
  text-align: center;
  font-size: 14pt;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.turnaround-option:hover {
  border: 3px solid lighten(#43a047, 35%);
  background: lighten(#43a047, 51%);
  background: #fff;
  color: lighten(#43a047, 10%);
}
.turnaround-option-selected,
.turnaround-option-selected:hover {
  // background: lighten(#43a047, 8%);
  // border: 3px solid lighten(#43a047, 8%);
  // color: #fff;
  border: 3px solid lighten(#43a047, 25%);
  background: lighten(#43a047, 53%);
  background: #fff;
  color: lighten(#43a047, 0%);

  color: lighten(#43a047, 10%);
  background: lighten(#43a047, 60%);
  background: lighten(#43a047, 16%);
  border: 3px solid lighten(#43a047, 6%);
  color: #fff;
  cursor: default !important;
}

.turnaround-label {
  width: 60px;
  margin-top: 7px;
  padding-left: 12px;
  color: lighten(#43a047, 20%);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 11.5pt;
}
.turnaround-check {
  position: relative;
  top: -13px;
  left: 16px;
  border-radius: 16px;
  opacity: 0;
}
.turnaround-check-icon {
  color: lighten(#5bb1f6, 13%);
  color: $color-blue;

  //color: darken(#ffe0b2, 20%) !important;
  font-size: 13.5pt;
}
.turnaround-option-selected .turnaround-check {
  opacity: 1 !important;
}

.upgrade-item {
  width: 100%;
  padding: 12px 0 12px 0;
  border-top: 2px solid #f3f3f3;
  display: flex;

  .upgrade-checkbox {
    margin: 0px 0px 4px 20px;
    width: 28px;
    min-width: 28px;
    height: 32px;
    background: #fff;
    border: 0px solid #eee;
    border-radius: 4px;
  }

  .upgrade-label {
    padding-left: 20px;
    padding-top: 2px;
    font-size: 15pt;
    font-weight: 600;
    color: $color-blue;
  }

  .upgrade-more {
    padding-left: 1px;
    padding-top: 6px;
    font-size: 13pt;
    font-weight: 500;
    line-height: 1.35em;
    color: #111;

    p {
      font-size: 12pt;
      padding: 0;
      margin-bottom: 10px;
    }
  }
}

.upgrade-item-speedy {
  .upgrade-label {
    color: lighten(#43a047, 1%);
  }
  .checkbox-icon {
    color: lighten(#43a047, 37%);
  }
  .checkbox-icon:hover {
    color: lighten(#43a047, 28%);
    cursor: pointer;
  }
  .upgrade-checkbox-checked .checkbox-icon {
    color: lighten(#43a047, 5%);
  }
  .upgrade-checkbox-checked .checkbox-icon:hover {
    color: darken(#43a047, 0%);
  }
}

.points-tag {
  display: flex;
  background: #fff;
  padding: 2px 14px 0 0;

  .points-icon {
    font-size: 24px;
    margin: 0;
    padding: 0;
    padding-left: 1px;
    line-height: 26px;
    color: $color-snaps;
  }
  .points-number {
    padding: 0px 0 0 5px;
    font-size: 14pt;
    font-weight: 600;
    line-height: 25px;
    color: darken($color-snaps, 0%);
  }
  .points-increase {
    padding-right: 5px;
    font-size: 16pt;
    font-weight: 600;
    line-height: 25px;
    color: darken($color-snaps, 0%);
  }
}
.pulseOnce {
  animation: pulse .3s normal;
}
</style>


